module.exports = __webpack_public_path__ + "static/media/home.d6c2dd8c.svg";